import _ from 'lodash'

export default function parseThemeStyleUnit(value) {
  if (_.isNumber(value)) return `${value / 10}rem`
  return value
}
